import React from 'react';
import ProtectedRoute from './protected';
import SalaryAdvancePage from '../pages/salary-advance';
import ReimbursementPage from '../pages/salary-advance';

export const SalaryAdvanceRoutes = [
  <ProtectedRoute exact path='/salary-advance' component={ReimbursementPage} />,
];